import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row loading-view"
}
const _hoisted_2 = {
  key: 1,
  class: "row loading-view"
}
const _hoisted_3 = {
  key: 2,
  class: "row router-view"
}
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = {
  key: 1,
  class: "row"
}
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = {
  key: 1,
  class: "row"
}
const _hoisted_8 = { class: "row wrapper-view" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "outside-div" }, null, -1)

export function render(_ctx, _cache) {
  const _component_c_loading = _resolveComponent("c-loading")
  const _component_router_view = _resolveComponent("router-view")
  const _component_c_sidebar = _resolveComponent("c-sidebar")
  const _component_c_navbar = _resolveComponent("c-navbar")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$store?.state?.appMode)
  }, [
    (_ctx.$store?.state?.processLoad && _ctx.$route.name != 'login-view')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_c_loading, { loading: true })
        ]))
      : (_ctx.serverError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t("errorServerError")), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (!_ctx.$helper?.accessToken?.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_router_view)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (!_ctx.$store?.state?.menus && !_ctx.$store?.state?.menus.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_c_loading, { loading: true })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (_ctx.$store?.state?.menus && _ctx.$store?.state?.menus.length)
                          ? (_openBlock(), _createBlock(_component_c_sidebar, { key: 0 }))
                          : _createCommentVNode("", true),
                        (_ctx.$store?.state?.menus && _ctx.$store?.state?.menus.length)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass([_ctx.$helper?.getSidebars?.value?.width === 'fix-sidebar' ? 'fix-content':'fix-content-min', "container-view"])
                            }, [
                              _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("nav", null, [
                                  _createVNode(_component_c_navbar)
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass([_ctx.$route.name === 'viewStock' ? `container-scroll-active` : ``, "container-scroll"])
                                }, [
                                  _createVNode(_component_router_view, { class: "row animate-bottom" })
                                ], 2)
                              ])
                            ], 2))
                          : _createCommentVNode("", true)
                      ]))
                ]))
          ])),
    _hoisted_9
  ], 2))
}